/**
 * Centralized React Query keys for the app.
 * Use these constants instead of string literals for consistency and refactor safety.
 */

export const queryKeys = {
  /** Full CRM board: pipelines, stages, deals, contacts */
  crmBoard: ["crm-board"] as const,
  /** CRM contacts list */
  crmContacts: ["crm-contacts"] as const,
  /** Single CRM contact detail */
  crmContactById: (id?: string | null) => ["crm-contact", id ?? ""] as const,
  /** CRM deals list (filtered/paginated); often invalidated after board mutations */
  crmDeals: ["crm-deals"] as const,
  /** CRM product types; second element is language */
  crmProductTypes: (lang?: string) => (lang ? ["crm-product-types", lang] as const : ["crm-product-types"] as const),
  /** Bevásárló lista (kocsiba + rendelés) */
  shoppingList: ["shopping-list"] as const,
  /** Galéria térkép: EXIF GPS fotók */
  galleryGeo: ["gallery-geo-photos"] as const,
  /** Szűrő bucket számok: összes bemeres+munkaink fotó meta szerint */
  galleryPhotoFacets: ["gallery-photo-facets"] as const,
  /** Social assets generated from gallery photos */
  socialAssetsByPhotoIds: (photoIds: string[]) => ["social-assets", ...photoIds.slice().sort()] as const,
} as const;
